import React from "react";
import InfoPage from ".";

const PrivacyPolicy = () => {
  const below = (
    <div style={{
      gridColumn: '1 / -1',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: '40px 20px',
      width: '100%',
      maxWidth: '900px',
      margin: '0 auto',
      fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
      fontSize: '14px',
      lineHeight: '1.8',
      color: '#0f084b'
    }}>
      <h1 style={{ 
        fontFamily: "'Sailors', serif", 
        fontSize: '36px', 
        marginBottom: '16px', 
        textAlign: 'center' 
      }}>
        POSTAWAY.COM
      </h1>
      
      <h2 style={{ 
        fontFamily: "'Sailors', serif", 
        fontSize: '28px', 
        marginBottom: '16px', 
        textAlign: 'center' 
      }}>
        Privacy Policy
      </h2>

      <p style={{ 
        marginBottom: '32px', 
        textAlign: 'center',
        fontSize: '14px',
        color: '#666'
      }}>
        Last updated November 11, 2025
      </p>

      <div style={{ width: '100%' }}>
        <p style={{ marginBottom: '16px' }}>
          Fed Up Foods, LLC, doing business as Postaway (the "Company"), respects your privacy. In that regard, we have created this Privacy Policy to let you know what information we collect when you visit our site, why we collect it, and how it is used. By using this Web site, you consent to the data practices prescribed in this Privacy Policy. The Company's Privacy Policy governs the privacy guidelines for the Company's Web site at www.Postaway.com (the "Site").
        </p>

        <h3 style={{ fontSize: '20px', fontWeight: '700', marginTop: '32px', marginBottom: '16px' }}>
          What information does the Company collect?
        </h3>
        <p style={{ marginBottom: '16px' }}>
          "Personal Information" means any information that may be used to identify an individual, including, but not limited to, first and last name, home or other physical address, an email address, phone number, or other contact information, whether at work or at home.
        </p>
        <p style={{ marginBottom: '16px' }}>
          In a few areas on our Site and online customer support tools, we ask you to provide Personal Information that will enable us to enhance your use of the Site or for purposes such as facilitating correspondence with you, registering your entitlement to access certain special features of the Site, or to complete transactions. It is always your choice whether or not to provide that Personal Information. If you choose not to provide requested Personal Information, you may not be able to use certain features of the Site.
        </p>
        <p style={{ marginBottom: '16px' }}>
          We may also automatically receive and record information on our server logs from your browser, which could include your IP address, cookie information, browser information, and the page you request.
        </p>

        <h3 style={{ fontSize: '20px', fontWeight: '700', marginTop: '32px', marginBottom: '16px' }}>
          How does the Company use Personal Information?
        </h3>
        <p style={{ marginBottom: '16px' }}>
          The Personal Information you provide will be kept confidential and used to support your customer relationship with the Company. Among other things, we want to help you quickly find information on our Site and alert you to product upgrades, special offers, updated information and other new products and services from the Company. The Company may enhance or merge your information collected at the Site with data from third parties for purposes of marketing products or services to you.
        </p>
        <p style={{ marginBottom: '16px' }}>
          Periodically, we may send you information about our various products and services, or other products and services we feel may be of interest to you. These mailings may be sent electronically or in physical form. Only the Company (or agents or contractors working on behalf of the Company and under confidentiality agreements) will send you these mailings. If you do not want to receive such mailings, simply tell us when you give us your Personal Information. Or, at any time you can easily opt-out of receiving further marketing from the Company by contacting us and requesting to have your name removed from our marketing lists. In addition, with respect to mailings sent via email, you may also click the "unsubscribe" link in the email to have your email address removed from our marketing list. All requests to unsubscribe will be handled in a prompt and efficient manner and in accordance with applicable law.
        </p>

        <h3 style={{ fontSize: '20px', fontWeight: '700', marginTop: '32px', marginBottom: '16px' }}>
          Updating Your Personal Information
        </h3>
        <p style={{ marginBottom: '16px' }}>
          To update any of your personal information or to change any of your marketing preferences, you may either contact us at <a href="mailto:info@postaway.com" style={{ color: '#dc1d08' }}>info@postaway.com</a> or in certain cases you may update your personal information through the Site by logging in and accessing your profile.
        </p>

        <h3 style={{ fontSize: '20px', fontWeight: '700', marginTop: '32px', marginBottom: '16px' }}>
          Information Sharing and Disclosure to Third Parties
        </h3>
        <p style={{ marginBottom: '16px' }}>
          Agents or contractors of the Company may have access to your Personal Information for the purpose of performing services on behalf of the Company. All such agents or contractors who have access to your Personal Information are required to keep the information confidential and not use it for any other purpose than to carry out the services they are performing for the Company or as otherwise required by law. In addition, information collected about you may be shared with other third parties as expressly stated on the page on which you provided such information.
        </p>
        <p style={{ marginBottom: '16px' }}>
          Except as set forth above, the Company does not rent, sell or share Personal Information it collects about you to or with third parties. Personal Information collected from you is only used to provide you with the Company products and services and to comply with any requirements of law. The Company or its agents or contractors may disclose Personal Information if required to do so by law or in the good faith belief that such action is necessary to: (1) conform to the edicts of the law or comply with legal process; (2) protect and defend the rights or property of the Company or its agents or contractors; or (3) act in urgent circumstances to protect the personal safety of users of the Company, its Web sites or the public. If the Company should ever file for bankruptcy or merge with another company, we may sell the information you provide to us on this Site to a third party or share your Personal Information with any company with whom we merge.
        </p>

        <h3 style={{ fontSize: '20px', fontWeight: '700', marginTop: '32px', marginBottom: '16px' }}>
          Security of Your Information
        </h3>
        <p style={{ marginBottom: '16px' }}>
          Any online payment transactions occurring on the Site will be secured using industry standard encryption technology (e.g., Secure Sockets Layer).
        </p>
        <p style={{ marginBottom: '16px' }}>
          You are solely responsible for maintaining the secrecy of your passwords or any account information. Please be careful and responsible whenever you're online. If you post Personal Information online that is accessible to the public, you may receive unsolicited messages from other parties in return. While we strive to protect your Personal Information, the Company does not ensure or warrant the security of any information you transmit to us, and you do so at your own risk.
        </p>

        <h3 style={{ fontSize: '20px', fontWeight: '700', marginTop: '32px', marginBottom: '16px' }}>
          Third-Party Sites
        </h3>
        <p style={{ marginBottom: '16px' }}>
          Please be aware that other Web sites that may be accessed through our site may collect personally identifiable information about you. This Privacy Policy does not cover the information practices of those third-party Web sites linked to our Site.
        </p>

        <h3 style={{ fontSize: '20px', fontWeight: '700', marginTop: '32px', marginBottom: '16px' }}>
          International Transfers
        </h3>
        <p style={{ marginBottom: '16px' }}>
          Personal Information collected on this Site may be stored and processed in the United States or any other country in which the Company or its affiliates, subsidiaries, agents or contractors maintain facilities, and by using this Site, you consent to any such transfer of information outside of your country.
        </p>

        <h3 style={{ fontSize: '20px', fontWeight: '700', marginTop: '32px', marginBottom: '16px' }}>
          Children's Privacy
        </h3>
        <p style={{ marginBottom: '16px' }}>
          This Site is not intended for or directed to persons under the age of 13. Any person who provides their information to the Company through the account login page for new customers or any other part of the Site represents to the Company that they are 13 years of age or older.
        </p>

        <h3 style={{ fontSize: '20px', fontWeight: '700', marginTop: '32px', marginBottom: '16px' }}>
          Your Consent to this Privacy Policy
        </h3>
        <p style={{ marginBottom: '16px' }}>
          By using this Site, you agree to this Privacy Policy. This is our entire and exclusive Privacy Policy and it supersedes any earlier version. We may change this Privacy Policy by posting a new version of this Privacy Policy on this Site, and it is your responsibility to review this page periodically. When we do change the policy, we will also revise the "last updated" date at the Privacy Policy. Your continued use of this Site constitutes your agreement to this Privacy Policy and any updates.
        </p>

        <h3 style={{ fontSize: '20px', fontWeight: '700', marginTop: '32px', marginBottom: '16px' }}>
          Contacting the Company
        </h3>
        <p style={{ marginBottom: '16px' }}>
          For questions or comments regarding this Privacy Policy, please contact us at:
        </p>
        <p style={{ marginBottom: '16px', marginLeft: '24px' }}>
          Fed Up Foods, LLC, doing business as Postaway<br/>
          <br/>
          P.O. Box 12829<br/>
          Dallas, Texas 75225<br/>
          <br/>
          <a href="mailto:info@postaway.com" style={{ color: '#dc1d08' }}>info@postaway.com</a>
        </p>

        <div style={{ textAlign: 'center', marginTop: '48px' }}>
          <a 
            href="/" 
            style={{ 
              color: '#dc1d08', 
              textDecoration: 'none',
              fontSize: '16px',
              fontWeight: '600'
            }}
          >
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );

  return (
    <InfoPage
      title=""
      below={below}
      divider={false}
      disableStamps={true}
      tallOverride={false}
      customMinHeight={7000}
    />
  );
};

export default PrivacyPolicy;
